import { API_URL } from "../../constants/pathConstants"
import { userStateData } from "../../data/userStateData"

class UpdateConnector {
	requestInProgress: boolean = false

	public async updateUserProfilePicsRequest(id: string, profile_pics: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UpdateConnector] updateUserProfilePicsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}update-customer-profile-pic`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"profile_pics": profile_pics
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UpdateConnector] - updateUserProfilePicsRequest() failed')
			console.log(err)
			return false
		}
	}

	public async updateUserDataRequest(id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UpdateConnector] updateUserDataRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}update-customer-data`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"userData": userStateData.getUserData()
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UpdateConnector] - updateUserProfilePicsRequest() failed')
			console.log(err)
			return false
		}
	}

	public async updateInstructorProfilePicsRequest(id: string, profile_pics: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UpdateConnector] updateInstructorProfilePicsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}update-instructor-profile-pic`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"profile_pics": profile_pics
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UpdateConnector] - updateUserProfilePicsRequest() failed')
			console.log(err)
			return false
		}
	}

	public async updateInstructorDataRequest(id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [UpdateConnector] updateInstructorDataRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${API_URL}update-instructor-data`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"userData": userStateData.getInstructorUpdateUserData()
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UpdateConnector] - updateUserProfilePicsRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const updateConnector: UpdateConnector = new UpdateConnector()